import { HarmonyChat } from '@rapidsos/harmony-chat';
import '@rapidsos/harmony-chat/dist/harmony-chat.css';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getAPIHost } from '@rsos/base-utils/metaTags';
import { hideHarmonyChat } from '@rsos/reduxDataStore/src/features/harmonyChat/harmonyChatSlice';
import { useTheme } from '@rsos/theme/styled';
import { getAccessToken } from '../../utils/accessTokenProvider';
import styles from './HarmonyChatWrapper.module.scss';
import { harmonyChatTheme } from './harmonyChatTheme';

export const HarmonyChatWrapper = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleClose = useCallback(() => {
    dispatch(hideHarmonyChat());
  }, [dispatch]);

  // memoize the API host
  const apiHost = useMemo(() => getAPIHost(), []);

  return (
    <div className={`${styles.chatContainer} bg-background`}>
      <HarmonyChat
        suggestions={[
          'How do I submit my agency’s Jurisdictional Boundary File?',
          "What's the weather today in San Diego?",
          'How do I add users to RapidSOS Unite?',
        ]}
        isDarkMode={theme.colors.name.toLowerCase() === 'dark'}
        baseApiHost={apiHost}
        agentUriPath="/v1/harmony-chat-proxy/chat"
        authHandler={getAccessToken}
        theme={harmonyChatTheme}
        onClose={handleClose}
        disclaimer="Ask Harmony is in beta and can make mistakes. RapidSOS cannot guarantee accuracy."
      />
    </div>
  );
};
